import Vue from "vue";
import axios from "axios";
import {reactive, toRefs, computed, provide, inject, isRef} from "@vue/composition-api";
import {updateListState, listStateMerge} from "../store_helpers";

export const state = reactive({
    list: []
});

export const actions = {
    fetchClientGroups(account_id, params = null) {
        return new Promise(function (resolve, reject) {
            axios
                .get(Vue.config.url_prefix + "/api/a/{0}/client_groups/".format(account_id), {params: params})
                .then(function (resp) {
                    state.list = listStateMerge(state.list, resp.data, "account_id", account_id, "id");
                    resolve(resp.data);
                })
                .catch(function (ex) {
                    reject(ex);
                });
        });
    },
    saveClientGroup(data) {
        return new Promise(function (resolve, reject) {
            axios
                .post(Vue.config.url_prefix + "/api/a/{0}/client_groups/".format(data.account_id), data)
                .then(function (resp) {
                    updateListState(resp.data.id, resp.data, state.list, "id", true);
                    resolve();
                })
                .catch(function (ex) {
                    reject(ex);
                });
        });
    },
    deleteClientGroup(data, raiseError = true) {
        return new Promise(function (resolve, reject) {
            data.raise_error = raiseError

            axios
                .delete(Vue.config.url_prefix + "/api/a/{0}/client_groups/".format(data.account_id), {data: data})
                .then(function () {
                    updateListState(data.id, null, state.list);
                    resolve();
                })
                .catch(function (ex) {
                    reject(ex);
                });
        });
    }
};

export const getters = {
    client_groups: computed(() => state.list),
    client_groups_by_account: acc_id =>
        computed(() => {
            const account_id = isRef(acc_id) ? acc_id.value : acc_id;
            return state.list.filter(group => group.account_id === account_id);
        })
};

export const key = Symbol("ClientGroupModule");

export const provideClientGroup = () => {
    provide(key, {
        ...toRefs(state),
        ...getters,
        ...actions
    });
};

export default () => inject(key);
